import React, { Fragment, useEffect, useState } from "react";
import styles from './practitioner.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizations } from '../../store/features/organizationSlice';
import Pagination from '../../models/Pagination';
import AtomicSpinner from 'atomic-spinner';
import TableControl from '../../component/_shared/table/tableControl';

const PractitionerView = ({ practitioner }) => {
    const dispatch = useDispatch();
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const tokenData = useSelector((state) => state.user.providerDirectoryTokenData);

    const [pagination, setPagination] = useState({ ...(new Pagination(1, 10, '', 'ASC')) });

    useEffect(() => {
        getOrganizations();
    }, [practitioner, pagination?.pageIndex, pagination?.pageSize, pagination?.sortCol, pagination?.sortType]);

    const getOrganizations = () => {
        setLoading(true);
        dispatch(fetchOrganizations({
            practitionerId: practitioner.resource.id.value,
            pagination,
            token: tokenData.access_token,
            callback: (response) => {
                setOrganizations(response);
                setPagination(new Pagination().set(pagination).setCount(response.Rows))
                setLoading(false);
            },
            catch: (error) => {
                setLoading(false);
                alert(error.message);
            }
        }));
    };

    const mountRows = () => {
        return organizations.Data.entry.map((item, index) => {
            return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                <td className={styles.tableColumn}>
                    <p>{item.resource.id.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.name.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.alias && item.resource.alias?.length > 0 ? item.resource.alias.map(item => item.value).join(', ') : ''}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.contact && item.resource.contact?.length > 0 ? item.resource.contact?.map((item) => item.name.text.value).join(', ') : ''}</p>
                </td>
            </tr>
        });
    };


    const getList = () => {
        return (
            loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
                :
                <Fragment>
                    <table className={styles.organizationTable}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Alias</th>
                                <th>Contact</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                organizations && organizations.Data.entry?.length > 0 ?
                                    mountRows()
                                    :
                                    <tr>
                                        <td colSpan='3'>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {organizations && organizations.Data.entry?.length > 0 ? <TableControl pagination={pagination} setPagination={setPagination} /> : <></>}
                </Fragment>
        );
    };

    return (
        <div>
            <table className={styles.practitionerTableView}>
                <tbody>
                    <tr key='1' >
                        <td className={styles.tableColumn}>
                            <h3>Id:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{practitioner.resource.id.value}</p>
                        </td> 
                    </tr>
                    <tr key='2' >
                        <td className={styles.tableColumn}>
                            <h3>Name:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{practitioner.resource.name?.map((item) => item.text.value).join(', ')}</p>
                        </td>
                    </tr>
                    <tr key='3' >
                        <td className={styles.tableColumn}>
                            <h3>Gender:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{practitioner.resource.gender.value}</p>
                        </td>
                    </tr>
                    <tr key='4' >
                        <td className={styles.tableColumn}>
                            <h3>Birth Date:</h3>
                        </td>
                        <td className={styles.tableColumn}>
                            <p>{practitioner.resource.birthDate ? new Date(practitioner.resource.birthDate.value).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }) : ''}</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div>
                <h3>Organizations</h3>
                {getList()}
            </div>

        </div>
    );
};

export default PractitionerView;